import * as type from '../constants/firmware'

const initialState = {
  availableFirmwares: [],
  firmwareForUpdate: '',
  inProgress: false,
  firmwareStatus: { step: '', progress: 0, totalProgress: 0 },
}

export default function firmware(state = initialState, action) {
  switch (action.type) {
  case type.SAVE_AVAILABLE_FIRMWARES:
    return { ...state, availableFirmwares: action.firmwares }
  case type.SET_FIRMWARE_FOR_UPDATE:
    return { ...state, firmwareForUpdate: action.pickedFirmware }
  case type.SET_FIRMWARE_STATUS:
    return { ...state, firmwareStatus: action.status }
  case type.RESET_FIRMWARE_STATUS:
    return { ...state, firmwareStatus: initialState.firmwareStatus }
  default:
    return state
  }
}
